export default [

  {
    id: 0,
    img: 'https://media.musiciansfriend.com/is/image/MMGS7/MU40C-Concert-Ukulele-Natural/J48865000001000-00-220x220.jpg',
    name: 'Mitchell MU40C Concert Ukulele',
    state: 'New',
    from: 'Juiz de Fora, Brazil',
    price: 69.99,
  },
  {
    id: 1,
    img: 'https://media.musiciansfriend.com/is/image/MMGS7/MU40-Soprano-Ukulele-Natural/J22069000001000-00-220x220.jpg',
    name: 'Mitchell MU40 Soprano Ukulele ',
    state: 'Used',
    from: 'Além Paraíba, Brazil',
    price: 37.99,
  },
  {
    id: 2,
    img: 'https://media.musiciansfriend.com/is/image/MMGS7/Soprano-Vintage-Mahogany-Ukulele-Natural/J32937000001000-00-220x220.jpg',
    name: 'Luna Guitars Soprano Vintage Mahogany Ukulele',
    state: 'New',
    from: 'Rio de Janeiro, Brazil',
    price: 49.99,
  },
  {
    id: 3,
    img: 'https://media.musiciansfriend.com/is/image/MMGS7/MU50SE-Acoustic-Electric-Concert-Ukulele-With-Solid-Cedar-Top-Natural/J55775000001000-00-220x220.jpg',
    name: 'Mitchell MU50SE Acoustic-Electric Concert Ukulele With...',
    state: 'New',
    from: 'Juiz de Fora, Brazil',
    price: 39.99,
  },
];
